import { IRewardFlow } from '../interfaces/IRewardFlow';
import errorHelper from '../helpers/errors';

class Rewards {
    static GetSiteRewardFlows = (siteId: number, signal?: AbortSignal): Promise<IRewardFlow[]> => {
        return fetch(`rewards/flows/${siteId}`, { signal })
            .then((response) => errorHelper.handleErrors(response))
            .then((response) => response.json() as Promise<IRewardFlow[]>);
    };
}

export default Rewards;
